import { ReactNode } from 'react';

export enum IconsEnum {
  x = 'x',
  facebook = 'facebook',
  instagram = 'instagram',
  youtube = 'youtube',
  linkedin = 'linkedin',
  whatsapp = 'whatsapp',
  donate = 'donate',
  list = 'list',
  rocket = 'rocket',
  wifiOff = 'wifiOff',
  menu = 'menu',
  money = 'money',
  'address-book-tabs' = 'address-book-tabs',
  'administração-de-drogas' = 'administração-de-drogas',
  'airplay' = 'airplay',
  'align-bottom' = 'align-bottom',
  'align-center-horizontal' = 'align-center-horizontal',
  'align-center-vertical' = 'align-center-vertical',
  'align-left' = 'align-left',
  'align-right' = 'align-right',
  'align-top' = 'align-top',
  'american' = 'american',
  'anestesiologia' = 'anestesiologia',
  'armchair' = 'armchair',
  'arrow-arc-left' = 'arrow-arc-left',
  'arrow-arc-right' = 'arrow-arc-right',
  'arrow-bend-up-left' = 'arrow-bend-up-left',
  'arrow-bend-up-right' = 'arrow-bend-up-right',
  'arrow-clockwise' = 'arrow-clockwise',
  'arrow-counter-clockwise' = 'arrow-counter-clockwise',
  'arrow-down-left' = 'arrow-down-left',
  'arrow-down-right' = 'arrow-down-right',
  'arrow-down' = 'arrow-down',
  'arrow-elbow-down-left' = 'arrow-elbow-down-left',
  'arrow-elbow-down-right' = 'arrow-elbow-down-right',
  'arrow-elbow-up-left' = 'arrow-elbow-up-left',
  'arrow-elbow-up-right' = 'arrow-elbow-up-right',
  'arrow-left' = 'arrow-left',
  'arrow-right' = 'arrow-right',
  'arrow-square-out' = 'arrow-square-out',
  'arrow-up-left' = 'arrow-up-left',
  'arrow-up-right' = 'arrow-up-right',
  'arrow-up' = 'arrow-up',
  'arrows-clockwise' = 'arrows-clockwise',
  'arrows-counter-clockwise' = 'arrows-counter-clockwise',
  'arrows-down-up' = 'arrows-down-up',
  'arrows-in-line-vertical' = 'arrows-in-line-vertical',
  'arrows-in-simple' = 'arrows-in-simple',
  'arrows-left-right' = 'arrows-left-right',
  'arrows-out-cardinal' = 'arrows-out-cardinal',
  'arrows-out-line-vertical' = 'arrows-out-line-vertical',
  'arrows-out-simple' = 'arrows-out-simple',
  'arrows-out' = 'arrows-out',
  'at' = 'at',
  'atlas-de-dermatologia' = 'atlas-de-dermatologia',
  'atlas-de-radiologia' = 'atlas-de-radiologia',
  'atlas-oftalmologia' = 'atlas-oftalmologia',
  'atlas-ortopedia' = 'atlas-ortopedia',
  'baby' = 'baby',
  'barcode' = 'barcode',
  'basket' = 'basket',
  'battery-charging' = 'battery-charging',
  'battery-full' = 'battery-full',
  'battery-high' = 'battery-high',
  'battery-low' = 'battery-low',
  'battery-medium' = 'battery-medium',
  'bell-ringing' = 'bell-ringing',
  'bell-slash' = 'bell-slash',
  'bell-z' = 'bell-z',
  'bell' = 'bell',
  'bluetooth-off' = 'bluetooth-off',
  'bluetooth' = 'bluetooth',
  'book-open-text' = 'book-open-text',
  'book' = 'book',
  'bookmark-simple' = 'bookmark-simple',
  'broom' = 'broom',
  'browsers' = 'browsers',
  'building-office' = 'building-office',
  'buildings' = 'buildings',
  'calculadoras-escores' = 'calculadoras-escores',
  'calculadoras-obstetricas' = 'calculadoras-obstetricas',
  'calculadoras-pediatricas' = 'calculadoras-pediatricas',
  'calendar-blank' = 'calendar-blank',
  'calendar-check' = 'calendar-check',
  'calendar-dots' = 'calendar-dots',
  'calendar-plus' = 'calendar-plus',
  'calendar-slash' = 'calendar-slash',
  'camera-rotate' = 'camera-rotate',
  'camera-slash' = 'camera-slash',
  'camera' = 'camera',
  'cardholder' = 'cardholder',
  'cards-three' = 'cards-three',
  'caret-down' = 'caret-down',
  'caret-left' = 'caret-left',
  'caret-right' = 'caret-right',
  'caret-up-down' = 'caret-up-down',
  'caret-up' = 'caret-up',
  'cell-signal-full' = 'cell-signal-full',
  'cell-signal-off' = 'cell-signal-off',
  'chart-bar-horizontal' = 'chart-bar-horizontal',
  'chart-bar' = 'chart-bar',
  'chart-donut' = 'chart-donut',
  'chart-line-down' = 'chart-line-down',
  'chart-line-up' = 'chart-line-up',
  'chart-pie-slice' = 'chart-pie-slice',
  'chart-scatter' = 'chart-scatter',
  'chat-circle-dots' = 'chat-circle-dots',
  'chat-circle' = 'chat-circle',
  'chat-teardrop-slash' = 'chat-teardrop-slash',
  'chats-circle' = 'chats-circle',
  'check-circle' = 'check-circle',
  'check' = 'check',
  'checkbox-fill' = 'checkbox-fill',
  'checkbox' = 'checkbox',
  'checks' = 'checks',
  'cid' = 'cid',
  'circle-notch' = 'circle-notch',
  'circuitry' = 'circuitry',
  'clinical-drops' = 'clinical-drops',
  'clock-countdown-fill' = 'clock-countdown-fill',
  'clock-countdown' = 'clock-countdown',
  'clock-counter-clockwise' = 'clock-counter-clockwise',
  'clock-fill' = 'clock-fill',
  'clock' = 'clock',
  'close' = 'close',
  'closed-captioning' = 'closed-captioning',
  'cloud-arrow-down' = 'cloud-arrow-down',
  'cloud-arrow-up' = 'cloud-arrow-up',
  'cloud-slash' = 'cloud-slash',
  'cloud' = 'cloud',
  'codigo-de-etica' = 'codigo-de-etica',
  'coins' = 'coins',
  'compass' = 'compass',
  'condutas-cirurgicas' = 'condutas-cirurgicas',
  'condutas-ginecologicas' = 'condutas-ginecologicas',
  'condutas-pediatricas' = 'condutas-pediatricas',
  'contactless-payment' = 'contactless-payment',
  'cookie' = 'cookie',
  'copy' = 'copy',
  'copyright' = 'copyright',
  'corners-out' = 'corners-out',
  'couch' = 'couch',
  'credit-card' = 'credit-card',
  'criterios-diagnosticos' = 'criterios-diagnosticos',
  'crop' = 'crop',
  'crown-simple' = 'crown-simple',
  'cube' = 'cube',
  'cuidados-paleativos' = 'cuidados-paleativos',
  'currency-btc' = 'currency-btc',
  'currency-circle-dollar-fill' = 'currency-circle-dollar-fill',
  'currency-circle-dollar' = 'currency-circle-dollar',
  'currency-dollar-simple' = 'currency-dollar-simple',
  'currency-eur' = 'currency-eur',
  'currency-gbp' = 'currency-gbp',
  'cursor-text' = 'cursor-text',
  'cursor' = 'cursor',
  'database' = 'database',
  'decision-tracks' = 'decision-tracks',
  'desktop' = 'desktop',
  'device-mobile-speaker' = 'device-mobile-speaker',
  'device-tablet-speaker' = 'device-tablet-speaker',
  'devices' = 'devices',
  'diagnostico-diferencial' = 'diagnostico-diferencial',
  'dinners' = 'dinners',
  'documentos-atestados' = 'documentos-atestados',
  'dots-six-vertical' = 'dots-six-vertical',
  'dots-six' = 'dots-six',
  'dots-three-vertical' = 'dots-three-vertical',
  'dots-three' = 'dots-three',
  'download-simple' = 'download-simple',
  'drag-handle' = 'drag-handle',
  'drop' = 'drop',
  'ear-slash' = 'ear-slash',
  'eject' = 'eject',
  'elo' = 'elo',
  'emergencias-uti' = 'emergencias-uti',
  'envelope-open' = 'envelope-open',
  'envelope-simple' = 'envelope-simple',
  'equalizer' = 'equalizer',
  'eraser' = 'eraser',
  'exames-complementares' = 'exames-complementares',
  'export' = 'export',
  'eye-closed' = 'eye-closed',
  'eye-slash' = 'eye-slash',
  'eye' = 'eye',
  'eyedropper-sample' = 'eyedropper-sample',
  'eyedropper' = 'eyedropper',
  'factory' = 'factory',
  'fast-forward' = 'fast-forward',
  'file-plus' = 'file-plus',
  'file-text' = 'file-text',
  'file' = 'file',
  'film-reel' = 'film-reel',
  'film-slate' = 'film-slate',
  'film-strip' = 'film-strip',
  'fingerprint' = 'fingerprint',
  'flag' = 'flag',
  'flip-horizontal' = 'flip-horizontal',
  'flip-vertical' = 'flip-vertical',
  'folder-open' = 'folder-open',
  'folder-plus' = 'folder-plus',
  'folder-simple-lock' = 'folder-simple-lock',
  'folder' = 'folder',
  'frame-corners' = 'frame-corners',
  'funnel-simple-x' = 'funnel-simple-x',
  'funnel-simple' = 'funnel-simple',
  'funnel-x' = 'funnel-x',
  'funnel' = 'funnel',
  'gauge-fill' = 'gauge-fill',
  'gauge' = 'gauge',
  'gear' = 'gear',
  'gender-female' = 'gender-female',
  'gender-intersex' = 'gender-intersex',
  'gender-male' = 'gender-male',
  'gender-neuter' = 'gender-neuter',
  'gender-nonbinary' = 'gender-nonbinary',
  'gender-transgender' = 'gender-transgender',
  'gerenciador-de-plantao' = 'gerenciador-de-plantao',
  'gift' = 'gift',
  'globe-hemisphere-west' = 'globe-hemisphere-west',
  'globe' = 'globe',
  'glossario' = 'glossario',
  'gps-fix' = 'gps-fix',
  'gps-slash' = 'gps-slash',
  'guia-de-antimicrobianos' = 'guia-de-antimicrobianos',
  'guia-de-ecg' = 'guia-de-ecg',
  'guia-de-procedimentos' = 'guia-de-procedimentos',
  'guia-de-vm' = 'guia-de-vm',
  'guia-intoxicacao' = 'guia-intoxicacao',
  'guia-usg-beira-leito' = 'guia-usg-beira-leito',
  'hand-pointing' = 'hand-pointing',
  'hard-drives' = 'hard-drives',
  'headphones' = 'headphones',
  'heart-half' = 'heart-half',
  'heart' = 'heart',
  'hourglass-medium-fill' = 'hourglass-medium-fill',
  'hourglass-medium' = 'hourglass-medium',
  'house' = 'house',
  'image' = 'image',
  'images-square' = 'images-square',
  'info' = 'info',
  'infusao' = 'infusao',
  'interacao-medicamentosa' = 'interacao-medicamentosa',
  'intercorrencias-obstetricias' = 'intercorrencias-obstetricias',
  'key' = 'key',
  'keyhole' = 'keyhole',
  'laboratório' = 'laboratório',
  'laptop' = 'laptop',
  'lightbulb-filament' = 'lightbulb-filament',
  'lightning-slash' = 'lightning-slash',
  'lightning' = 'lightning',
  'link-break' = 'link-break',
  'link' = 'link',
  'list-bullets' = 'list-bullets',
  'lock-key-open' = 'lock-key-open',
  'lock-key' = 'lock-key',
  'logo-wb' = 'logo-wb',
  'magic-wand' = 'magic-wand',
  'magnifying-glass-minus' = 'magnifying-glass-minus',
  'magnifying-glass-plus' = 'magnifying-glass-plus',
  'magnifying-glass' = 'magnifying-glass',
  'manipulados' = 'manipulados',
  'map-pin-area' = 'map-pin-area',
  'map-pin' = 'map-pin',
  'map-trifold' = 'map-trifold',
  'master' = 'master',
  'medicamentos' = 'medicamentos',
  'medicine' = 'medicine',
  'medicina-de-familia' = 'medicina-de-familia',
  'medicina-esporte' = 'medicina-esporte',
  'medicina-interna' = 'medicina-interna',
  'megaphone' = 'megaphone',
  'microphone-slash' = 'microphone-slash',
  'microphone' = 'microphone',
  'minus-circle' = 'minus-circle',
  'minus' = 'minus',
  'moon' = 'moon',
  'mouse' = 'mouse',
  'music-notes' = 'music-notes',
  'navigation-arrow' = 'navigation-arrow',
  'newspaper-clipping' = 'newspaper-clipping',
  'newspaper' = 'newspaper',
  'notches' = 'notches',
  'note-blank' = 'note-blank',
  'note-pencil' = 'note-pencil',
  'note' = 'note',
  'numpad' = 'numpad',
  'nut' = 'nut',
  'oftalmologia' = 'oftalmologia',
  'orientacao-ao-paciente' = 'orientacao-ao-paciente',
  'ortopedia' = 'ortopedia',
  'otorrinolaringologia' = 'otorrinolaringologia',
  'package' = 'package',
  'paint-brush-broad' = 'paint-brush-broad',
  'paint-bucket' = 'paint-bucket',
  'paint-roller' = 'paint-roller',
  'palette' = 'palette',
  'paper-plane-tilt' = 'paper-plane-tilt',
  'paperclip' = 'paperclip',
  'paragraph' = 'paragraph',
  'parto-epuerperio' = 'parto-epuerperio',
  'pause-circle' = 'pause-circle',
  'pause' = 'pause',
  'pencil-simple' = 'pencil-simple',
  'phone-call' = 'phone-call',
  'phone-disconnect' = 'phone-disconnect',
  'phone-outgoing' = 'phone-outgoing',
  'phone-slash' = 'phone-slash',
  'phone-transfer' = 'phone-transfer',
  'phone-x' = 'phone-x',
  'piggy-bank' = 'piggy-bank',
  'play-circle' = 'play-circle',
  'play-pause' = 'play-pause',
  'play' = 'play',
  'playlist' = 'playlist',
  'plus-circle' = 'plus-circle',
  'plus' = 'plus',
  'podcast' = 'podcast',
  'power' = 'power',
  'pre-natal' = 'pre-natal',
  'prescicoes-cirurgicas' = 'prescicoes-cirurgicas',
  'prescricao' = 'prescricao',
  'prescricoes-pediatricas' = 'prescricoes-pediatricas',
  'prescritor-de-antibiotico' = 'prescritor-de-antibiotico',
  'procedimentos-pediatricos' = 'procedimentos-pediatricos',
  'produtos-farmaceuticos' = 'produtos-farmaceuticos',
  'prohibit' = 'prohibit',
  'push-pin-simple-slash' = 'push-pin-simple-slash',
  'push-pin-simple' = 'push-pin-simple',
  'qr-code' = 'qr-code',
  'question' = 'question',
  'queue' = 'queue',
  'radar' = 'radar',
  'radio-button-fill' = 'radio-button-fill',
  'radio-button' = 'radio-button',
  'record' = 'record',
  'repeat-once' = 'repeat-once',
  'repeat' = 'repeat',
  'reposicao-eletrolitica' = 'reposicao-eletrolitica',
  'rewind' = 'rewind',
  'rewind1' = 'rewind1',
  'risco-cirurgico' = 'risco-cirurgico',
  'rocket-launch' = 'rocket-launch',
  'rss' = 'rss',
  'ruler' = 'ruler',
  'scissors' = 'scissors',
  'screencast' = 'screencast',
  'seal-check' = 'seal-check',
  'semiologia' = 'semiologia',
  'share-fat' = 'share-fat',
  'share-network' = 'share-network',
  'shield-check' = 'shield-check',
  'shield-checkered' = 'shield-checkered',
  'shield-slash' = 'shield-slash',
  'shopping-bag' = 'shopping-bag',
  'shopping-cart' = 'shopping-cart',
  'shuffle' = 'shuffle',
  'sidebar-simple' = 'sidebar-simple',
  'sidebar-simple-filled' = 'sidebar-simple-filled',
  'sign-in' = 'sign-in',
  'sign-out' = 'sign-out',
  'skip-back' = 'skip-back',
  'skip-forward' = 'skip-forward',
  'sliders-horizontal' = 'sliders-horizontal',
  'sliders' = 'sliders',
  'some-checkbox-fill' = 'some-checkbox-fill',
  'sort-ascending' = 'sort-ascending',
  'sort-descending' = 'sort-descending',
  'sparkle' = 'sparkle',
  'speaker-high' = 'speaker-high',
  'speaker-low' = 'speaker-low',
  'speaker-none' = 'speaker-none',
  'speaker-simple-x' = 'speaker-simple-x',
  'speaker-slash' = 'speaker-slash',
  'spinner-gap' = 'spinner-gap',
  'squares-four' = 'squares-four',
  'stack' = 'stack',
  'star-half' = 'star-half',
  'star' = 'star',
  'storefront' = 'storefront',
  'sun' = 'sun',
  'sus' = 'sus',
  'text-align-center' = 'text-align-center',
  'text-align-justify' = 'text-align-justify',
  'text-align-left' = 'text-align-left',
  'text-align-right' = 'text-align-right',
  'text-aunderline' = 'text-aunderline',
  'text-b' = 'text-b',
  'text-columns' = 'text-columns',
  'text-hfour' = 'text-hfour',
  'text-hone' = 'text-hone',
  'text-hthree' = 'text-hthree',
  'text-htwo' = 'text-htwo',
  'text-indent' = 'text-indent',
  'text-italic' = 'text-italic',
  'text-outdent' = 'text-outdent',
  'text-strikethrough' = 'text-strikethrough',
  'text-underline' = 'text-underline',
  'thumbs-down' = 'thumbs-down',
  'thumbs-up' = 'thumbs-up',
  'ticket' = 'ticket',
  'timer-fill' = 'timer-fill',
  'timer' = 'timer',
  'trash' = 'trash',
  'trauma' = 'trauma',
  'tray' = 'tray',
  'trend-down' = 'trend-down',
  'trend-up' = 'trend-up',
  'trophy' = 'trophy',
  'tuss' = 'tuss',
  'upload-simple' = 'upload-simple',
  'usb' = 'usb',
  'user-check' = 'user-check',
  'user-circle' = 'user-circle',
  'user-list' = 'user-list',
  'user-plus' = 'user-plus',
  'user-sound' = 'user-sound',
  'user' = 'user',
  'users' = 'users',
  'vacinacao' = 'vacinacao',
  'vault' = 'vault',
  'video-camera-slash' = 'video-camera-slash',
  'video-camera' = 'video-camera',
  'visa' = 'visa',
  'warehouse' = 'warehouse',
  'warning-circle' = 'warning-circle',
  'warning' = 'warning',
  'waveform-slash' = 'waveform-slash',
  'waveform' = 'waveform',
  'wheelchair' = 'wheelchair',
  'wifi-high' = 'wifi-high',
  'wifi-off' = 'wifi-off',
  'wrench' = 'wrench',
  'xcircle' = 'xcircle',
  arrow = 'arrow',
  doctor = 'doctor',
  pen = 'pen',
}

export interface SvgWrapperProps {
  size?: number;
  altText?: string;
  color?: string;
  children: ReactNode;
  className: string;
}
export interface IconProps extends Pick<SvgWrapperProps, 'altText' | 'color'> {
  icon: keyof typeof IconsEnum;
  size?: number;
  className?: string;
}
